<template>
  <div class="form-counter">
    <div class="counter-container">
      <div v-if="!!label" class="counter-label" v-html="label" />
      <div class="counter-set">
        <button name="decrement" tabindex="0" aria-labelledby="decrement" @click.prevent.stop="decrement">
          <font-awesome-icon icon="minus" aria-label="minus" :class="minReached" />
        </button>
        <div class="counter-number" data-test="count">
          {{ count }}<span v-if="showPlus && value > 0">+</span>
        </div>
        <button name="increment" tabindex="0" aria-labelledby="increment" @click.prevent.stop="increment">
          <font-awesome-icon icon="plus" aria-label="plus" :class="maxReached" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCounter',
  props: {
    id: { type: [Number, String], default: Math.floor(Math.random() * 100) },
    label: { type: String },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 50 },
    setValue: { type: [Number, String], default: 0 },
    showPlus: { type: Boolean },
    showAll: { type: Boolean },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      value: 0,
    };
  },
  computed: {
    count() {
      return this.showAll && this.value === 0 ? 'All' : this.value;
    },
    maxReached() {
      return this.value === this.max || this.disabled ? 'faded-blue pointer' : 'text-light-blue pointer';
    },
    minReached() {
      return this.value === this.min || this.disabled ? 'faded-blue pointer' : 'text-light-blue pointer';
    },
  },
  watch: {
    setValue: {
      handler(n) {
        this.value = n;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    increment() {
      if (this.disabled == false) {
        this.value <= this.max - 1 ? this.value++ : this.value = this.max;
        this.$emit('value', this.value, this.id);
      }
    },
    decrement() {
      if (this.disabled == false) {
        this.value >= this.min + 1 ? this.value-- : this.value = this.min;
        this.$emit('value', this.value, this.id);
      }
    },
    reset() {
      this.value = 0;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/styles/settings/config.scss";

.form-counter{
  width: 100% !important;
}

.counter-container{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 5px;
  width: 100%;
}

.counter-label{
  font-size: 14px;
}

.counter-set {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 5px;
  align-items: center;
  justify-items: center;

  .counter-number{
      width: 30px;
      text-align: center;
      font-weight: 400;
  }

  .pointer {
    cursor: pointer !important;
  }
}

.faded-blue {
  color: $darkBlack;
  opacity: 0.2;
  //color: rgba(33, 193, 255, 0.25);
}

</style>
